import { render } from "./ItemPerformance.vue?vue&type=template&id=6e4f797e&scoped=true"
import script from "./ItemPerformance.vue?vue&type=script&lang=js"
export * from "./ItemPerformance.vue?vue&type=script&lang=js"

import "./ItemPerformance.vue?vue&type=style&index=0&id=6e4f797e&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4f797e"]])

export default __exports__